export default __webpack_public_path__ + "static/media/FlightOption3.0ef2f4c6.jpg";